import styled from 'styled-components';
import { Button, lightenDarkenColor } from '../shared/utils/styles';

export const Container = styled.div`
  /* grid-area: fbtns; */
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: #eee; */
  /* border: 1px solid gray; */
  /* padding: 0px 5px; */
  text-transform: uppercase;
  width: 100%;
`;

export const DecisionButton = styled(Button)`
  width: 100%;
  height: 50px;
  margin: 1px;
  padding: 10px 8px;
  font-size: 1em;
  margin: 10px 0px;
  position: relative;
  ${(props) => !props.disabled
    && props.firstClick
    && `border: 5px solid ${lightenDarkenColor(
      props.bgColor,
      props.bgColor === '#009E0F' ? 20 : -20,
    )};`}
  ${(props) => `tab-Index: ${props.tabIndex}`};
  ${(props) => props.invalid && 'cursor: not-allowed'};
`;

export const ButtonTextContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(5, 1fr);
`;

export const ButtonText = styled.div`
  grid-column: 2/5;
`;

export const HotKeyLabel = styled.div`
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 0.75em;
`;